/* template */
<template><div class="container"><mpx-image :src="(trainIconUrl)" class="icon"></mpx-image><div class="text">{{title}}</div></div></template>

/* styles */
<style lang="stylus" scoped mpxStyleOptions='{"mid":"m4ff8d9a0"}'>
.container
  display flex
  flex-direction column
  align-items center
  font-family PingFangSC-Medium
  font-size 24px
  font-weight normal
  line-height 1
  letter-spacing 0px
  color #000000
  .icon
    width 60px
    height 60px
    margin-bottom 13px
  .text
    min-height 30px
    line-height 30px
    max-width 100%
    word-break break-all

</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "m4ff8d9a0"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./banner.mpx.js?isComponent&outputPath=components%2Fbanner4ff8d9a0%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./banner.mpx?ctorType=component&index=0&isComponent&mpx&outputPath=components%2Fbanner4ff8d9a0%2Findex&type=script")
  const currentOption = global.__mpxOptionsMap["m4ff8d9a0"]
  export default processOption(
    currentOption,
    "component",
    "",
    "components/banner4ff8d9a0/index",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'mpx-image':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-image.vue?isComponent"), { __mpxBuiltIn: true })},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
